import styled from "@emotion/styled";

export const StyledContainer = styled("div")(() => ({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  justifyContent: "center",
  paddingBottom: "5rem",
}));
